import React from 'react';
import styles from "./PageWithSidebarStructureWithPoints.module.scss";
import PageWithSidebarStructure from 'gui/components/pageWithSidebarStructure';
import GuaranteesForSeller
  from 'gui/pages/mainRouter/pages/ad/components/commons/preparedAdStructure/components/purchaseForm/components/guaranteesForSeller';

export interface IPageWithSidebarStructureWithPointsProps {
  className?: string;
  getStepProductInfo?: () => any;
  children?: any;
}

const PageWithSidebarStructureWithPoints = (props: IPageWithSidebarStructureWithPointsProps) => {
  return (
    <PageWithSidebarStructure
      className={`${styles.editorStructure} ${props.className}`.trim()}
      navigation={
        <div className={styles.topPoints}>
          <GuaranteesForSeller
            aboveComponents={props.getStepProductInfo()}
          />
        </div>
      }>
      {props.children}
    </PageWithSidebarStructure>
  );
};

PageWithSidebarStructureWithPoints.defaultProps = {
  className: '',
  getStepProductInfo: () => null,
};

export default React.memo(PageWithSidebarStructureWithPoints);
